import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form/immutable';
import { List } from 'immutable';
import classNames from 'classnames';

import * as validators from '../../Form/validators';
import { ContactRecord } from '../../../entities/records';
import Button, { ButtonSmall } from '../../Button';
import Input from '../Input';
import PersonSelect, { CREATE_OPTION } from '../PersonSelect/PersonSelect';
import * as styles from './styles.css';
import CustomerName from '../../CustomerName/CustomerName';
import { useTranslation } from 'react-i18next';

function Contacts({
  fields,
  customerId,
  isEditable,
  values,
  displayAllContacts,
  toggleDisplayAllContacts,
  addField,
  isCorporateGroup,
}) {
  const { t } = useTranslation();
  return (
    <div>
      {fields.length === 0 && (
        <div>
          <i>{t("Inga kontakter finns sparade på denna kund.")}</i>
        </div>
      )}

      {fields.map((contact, index) => {
        const innerCustomerId = values.getIn([index, 'customer']);
        const currentCustomer = customerId === String(innerCustomerId);
        if (!currentCustomer && !displayAllContacts) {
          return null;
        }

        return (
          <div
            key={contact}
            className={classNames({ [styles.passive]: !currentCustomer })}
          >
            <Field
              label={t("Person")}
              name={`${contact}.person`}
              component={PersonSelect}
              isEditable={isEditable && currentCustomer}
              validate={currentCustomer ? validators.required() : undefined}
              creatable
              showCustomers
            />
            <Field
              label={t("Roll")}
              component={Input}
              name={`${contact}.role`}
              isEditable={isEditable && currentCustomer}
              validate={currentCustomer ? validators.required() : undefined}
            />
            {isEditable && currentCustomer && (
              <ButtonSmall
                disabled={!currentCustomer}
                icon="times-circle"
                iconStyle="danger"
                onClick={() => fields.remove(index)}
              />
            )}
            {!currentCustomer && (
              <div>
                <b>{t("Kund")}</b>
                <div style={{ padding: '7px 13px' }}>
                  <CustomerName customerId={innerCustomerId} />
                </div>
              </div>
            )}
            <hr />
          </div>
        );
      })}
      {isCorporateGroup && (
        <Button
          stretch
          size="sm"
          onClick={toggleDisplayAllContacts}
          className={styles.add}
        >
          {displayAllContacts ? t('Dölj') : t('Visa')}{t("koncernens kontakter")}
        </Button>
      )}
      <Button
        icon="plus-circle"
        iconStyle="success"
        stretch
        className={styles.add}
        onClick={addField}
      >
        {t("Lägg till kontakt")}
      </Button>
    </div>
  );
}

Contacts.propTypes = {
  fields: PropTypes.object.isRequired, //eslint-disable-line
  isEditable: PropTypes.bool.isRequired,
  customerId: PropTypes.string.isRequired,
  values: PropTypes.instanceOf(List).isRequired,
  displayAllContacts: PropTypes.bool.isRequired,
  toggleDisplayAllContacts: PropTypes.func.isRequired,
  addField: PropTypes.func.isRequired,
  isCorporateGroup: PropTypes.bool.isRequired,
};

export default compose(
  connect((state, { form, fields }) => ({ values: formValueSelector(form)(state, fields.name) })),
  withProps(({ customerId, values }) => {
    const isCorporateGroup = values ? !!values.find(value => value.get('customer') !== customerId) : false;
    return {
      isCorporateGroup,
    };
  }),
  withStateHandlers({
    displayAllContacts: false,
  }, {
    toggleDisplayAllContacts: ({ displayAllContacts }) => () =>
      ({ displayAllContacts: !displayAllContacts }),
  }),
  withProps(({ open, customerId, fields }) => ({
    addField: () => {
      open();
      fields.push(new ContactRecord({
        customer: customerId,
        person: CREATE_OPTION,
      }));
    },
  })),
)(Contacts);
